import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Modal,
  Space,
  Table,
  Form,
  Flex,
  TablePaginationConfig,
} from "antd";
import instance from "../../axios/axios-instance";
import { setSuccessMessage } from "../../redux/actions/AppMessageActions";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";

type AppDispatch = ThunkDispatch<any, unknown, AnyAction>;

interface Insurer {
  id: number;
  insurer_name: string;
}

function InsurersTable() {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [editInsurerForm] = Form.useForm();
  const [selectedInsurer, setSelectedInsurer] = useState<Insurer>();
  const [query, setQuery] = useState("");
  const dispatch = useDispatch<AppDispatch>();

  const fetchInsurers = async () => {
    const response = await instance.get("/api/administration/insurers");
    setData(response?.data);
    setFilteredData(response?.data);
  };
  useEffect(() => {
    fetchInsurers();
  }, []);

  const performSearch = () => {
    const filteredData = data.filter((insurer: Insurer) =>
      insurer.insurer_name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredData(filteredData);
  };

  const resetSearch = () => {
    setQuery("");
    setFilteredData(data);
  };

  const createNewInsurer = async () => {
    const response = await instance.post("/api/administration/insurers", {
      ...editInsurerForm.getFieldsValue(),
    });
    if (response?.status >= 200 && response?.status < 300) {
      dispatch(setSuccessMessage("Insurer added"));
      fetchInsurers();
    }
    setCreateModalOpen(false);
  };

  const editInsurer = async () => {
    const response = await instance.put(
      `/api/administration/insurers?id=${selectedInsurer?.id}`,
      {
        ...editInsurerForm.getFieldsValue(),
      }
    );
    if (response?.status >= 200 && response?.status < 300) {
      dispatch(setSuccessMessage("Insurer Updated"));
      fetchInsurers();
    }
    setEditModalOpen(false);
  };

  const handleDetails = (record: any) => {
    editInsurerForm.setFieldsValue({
      insurer_name: record.insurer_name,
    });
    setSelectedInsurer(record);
    setEditModalOpen(true);
  };

  function FormIsValid() {
    const data = editInsurerForm.getFieldsValue();
    return data.insurer_name;
  }

  const columns: any[] = [
    {
      title: "Insurer Name",
      dataIndex: "insurer_name",
      key: "insurer_name",
      width: 150,
      editable: true,
      fixed: "left",
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (record: any) => (
        <Space size="small" style={{ minWidth: "112px" }}>
          <Button onClick={() => handleDetails(record)}>Details</Button>
        </Space>
      ),
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [page_size, setPage_size] = useState(4);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    let timeoutId: any;

    // Define a function to update the window height with a delay
    const updateWindowHeight = () => {
      timeoutId = setTimeout(() => {
        setWindowHeight(window.innerHeight);
      }, 300);
    };

    // Attach the event listener when the component mounts
    window.addEventListener("resize", updateWindowHeight);

    // Remove the event listener and clear the timeout when the component unmounts
    return () => {
      window.removeEventListener("resize", updateWindowHeight);
      clearTimeout(timeoutId); // Clear any pending timeouts
    };
  }, []);

  console.log("insurer form", editInsurerForm.getFieldsValue());

  return (
    <Space direction="vertical">
      <Flex justify="space-between">
        <Space>
          <Input
            value={query}
            onChange={(e) => setQuery(e.target.value.trim())}
            placeholder="Enter search to begin"
          ></Input>
          <Button disabled={!query} onClick={() => performSearch()}>
            Search
          </Button>
          <Button
            disabled={!query.trim() || filteredData?.length === 0}
            onClick={() => resetSearch()}
          >
            Reset
          </Button>
        </Space>
        <Space align="end" direction="horizontal">
          <Button
            type="primary"
            onClick={() => {
              editInsurerForm.resetFields();
              setCreateModalOpen(true);
            }}
          >
            Add Insurer
          </Button>
        </Space>
      </Flex>
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey="id"
        scroll={{ y: windowHeight - 420 }}
        style={{ width: 650 }}
        onChange={(config: TablePaginationConfig) => {
          setPage_size(config.pageSize!);
          setCurrentPage(config.current!);
        }}
        pagination={{
          total: filteredData?.length,
          showTotal: (total) => `${total} rows`,
          pageSize: page_size,
          current: currentPage,
        }}
      />
      <Modal
        title="Create an Insurer"
        open={isCreateModalOpen}
        onOk={createNewInsurer}
        okText="Save"
        /* okButtonProps={{ disabled: !FormIsValid() }} */
        onCancel={() => {
          setCreateModalOpen(false);
        }}
      >
        <Form layout="vertical" form={editInsurerForm}>
          <Form.Item label="Insurer Name" name="insurer_name">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title="Edit Insurer"
        open={isEditModalOpen}
        onOk={editInsurer}
        okText="Update"
        /* okButtonProps={{ disabled: !FormIsValid() }} */
        onCancel={() => {
          setEditModalOpen(false);
        }}
      >
        <Form layout="vertical" form={editInsurerForm}>
          <Form.Item label="Insurer Name" name="insurer_name">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </Space>
  );
}

export default InsurersTable;
